import React from 'react';
import { TrendingUp, DollarSign, Clock, PieChart } from 'lucide-react';
import { useDeals } from '../../store/DealsContext';

export default function DealMetrics() {
  const { deals } = useDeals();
  
  const metrics = {
    totalValue: deals.reduce((sum, deal) => sum + deal.value, 0),
    avgDealSize: deals.length ? deals.reduce((sum, deal) => sum + deal.value, 0) / deals.length : 0,
    successRate: deals.length ? (deals.filter(d => d.status === 'completed').length / deals.length) * 100 : 0,
    activeDeals: deals.filter(d => d.status !== 'completed').length
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      <div className="bg-gradient-to-br from-blue-50 to-blue-100 p-6 rounded-xl">
        <div className="flex items-center justify-between">
          <h3 className="text-sm font-medium text-blue-900">Total Pipeline Value</h3>
          <DollarSign className="w-6 h-6 text-blue-600" />
        </div>
        <p className="mt-2 text-2xl font-bold text-blue-900">
          {new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            notation: 'compact',
            maximumFractionDigits: 1
          }).format(metrics.totalValue)}
        </p>
        <p className="mt-2 text-sm text-blue-700">+12% from last month</p>
      </div>

      <div className="bg-gradient-to-br from-purple-50 to-purple-100 p-6 rounded-xl">
        <div className="flex items-center justify-between">
          <h3 className="text-sm font-medium text-purple-900">Average Deal Size</h3>
          <TrendingUp className="w-6 h-6 text-purple-600" />
        </div>
        <p className="mt-2 text-2xl font-bold text-purple-900">
          {new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            notation: 'compact',
            maximumFractionDigits: 1
          }).format(metrics.avgDealSize)}
        </p>
        <p className="mt-2 text-sm text-purple-700">+5% from last month</p>
      </div>

      <div className="bg-gradient-to-br from-green-50 to-green-100 p-6 rounded-xl">
        <div className="flex items-center justify-between">
          <h3 className="text-sm font-medium text-green-900">Success Rate</h3>
          <PieChart className="w-6 h-6 text-green-600" />
        </div>
        <p className="mt-2 text-2xl font-bold text-green-900">
          {metrics.successRate.toFixed(1)}%
        </p>
        <p className="mt-2 text-sm text-green-700">+2% from last quarter</p>
      </div>

      <div className="bg-gradient-to-br from-orange-50 to-orange-100 p-6 rounded-xl">
        <div className="flex items-center justify-between">
          <h3 className="text-sm font-medium text-orange-900">Active Deals</h3>
          <Clock className="w-6 h-6 text-orange-600" />
        </div>
        <p className="mt-2 text-2xl font-bold text-orange-900">{metrics.activeDeals}</p>
        <p className="mt-2 text-sm text-orange-700">+3 new this month</p>
      </div>
    </div>
  );
}